<template>
    <div class="home">
        <MeterView_flatX v-if="tariff === 'X'" productTariff="FlatX" :componentData="bp_data" />
        <MeterView_direct2 v-else-if="tariff === 'direkt 2.0'" productTariff="direct 2.0" :componentData="bp_data" />
        <MeterView_direct v-else-if="tariff === 'direkt'" productTariff="direct" :componentData="bp_data" />
        <div class="container" v-else>
            <h1>no product given</h1>
        </div>
    </div>
</template>

<script>
import MeterView_flatX from "@/components/Meter_flatX.vue";
import MeterView_direct2 from "@/components/Meter_direct2.vue";
import MeterView_direct from "@/components/Meter_direct.vue";

export default {
    name: "MeterView",
    components: {
        MeterView_flatX,
        MeterView_direct2,
        MeterView_direct
    },
    data() {
        return { tariff: undefined, sf_mi: undefined, bp_data: undefined };
    },
    mounted() {},
    created() {
        var self = this;
        const mi_identifier = this.$route.params.id.toUpperCase();
        console.log("Creating resources ", mi_identifier);
        const api = `${this.$appConfig.SF_SERVER_URI}/bp/metering/meter_cabinet_check/webapp/${mi_identifier}/view`;
        const config = {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": this.$appConfig.SF_SERVER_TOKEN
            }
        };

        this.axios
            .get(api, config)
            .then((response) => {
                if (response.data.success) {
                    console.log("MI tariff", response.data.data);
                    self.bp_data = response.data.data;
                    self.tariff = response.data.data.tariff_version;
                    console.log(self.tariff);
                } else {
                    console.log("ERR with response", response);
                    self.status_error = true;
                    self.error_message = response;
                }
            })
            .catch((err) => {
                self.status_error = true;
                self.error_message = err;
            });
    }
};
</script>
